<template>
  <div class="form-out-view">
    <!-- //添加修改项目经历 -->
    <UserTitle :title="title"></UserTitle>
    <a-form :form="form" @submit="handleSubmit" class="form-all">
      <b-row>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="项目名称">
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: '请填写项目名称' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view"></b-col>

        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="项目类型">
            <a-input
              v-decorator="[
                'type',
                {
                  rules: [{ required: true, message: '请填写项目类型' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="	项目角色">
            <a-input
              v-decorator="[
                'role',
                {
                  rules: [{ required: true, message: '请填写	项目角色' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="项目开始时间">
            <a-date-picker
              placeholder="项目开始时间"
              style="width:100%"
              v-decorator="[
                'startTime',
                {
                  rules: [{ required: true, message: '项目开始时间' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="项目结束时间">
            <a-date-picker
              placeholder="项目结束时间"
              style="width:100%"
              v-decorator="['endTime']"
            />
          </a-form-item>
        </b-col>
        <a-form-item label="项目描述" class="all-input">
          <a-textarea
            v-decorator="[
              'desc',
              {
                rules: [{ required: true, message: '请填写项目描述' }]
              }
            ]"
            placeholder="请描述一下项目描述内容"
            :rows="8"
            allowClear
            :maxLength="500"
          />
        </a-form-item>
        <a-form-item class="form-footer">
          <a-button class="success-button usually-button" html-type="submit"
            >保存</a-button
          >
          <a-button class="disable-button usually-button" @click="goBack"
            >取消</a-button
          >
        </a-form-item>
      </b-row>
    </a-form>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      title: "编辑项目经历",
      id: this.$route.query.id || 0,
      type: this.$route.query.type || "add",
      loading: false,
      imageUrl: "",
      form: this.$form.createForm(this, {
        name: "projectForm"
      })
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    login() {
      return publicChange.userLogin();
    },
    async getData() {
      const login = this.login();
      if (login) {
        if (this.type == "edit" && this.id !== 0) {
          this.title = "修改项目经历";
          const ProjectHistory = await Api.User.getProjectHistoryDetail(
            this.id
          );
          if (ProjectHistory) {
            this.$nextTick(() => {
              this.form.setFieldsValue({
                name: ProjectHistory.name,
                type: ProjectHistory.type,
                role: ProjectHistory.role,
                desc: ProjectHistory.desc,
                startTime: this.$moment(ProjectHistory.enterTime) || null,
                endTime: this.$moment(ProjectHistory.leaveTime) || null
              });
            });
          }
        } else if (this.type == "add") {
          this.title = "新增项目经历";
        } else {
          this.$message.error("获取页面错误，请重新进入页面");
          this.$router.push("/user/talent");
        }
      } else {
        this.$router.push({
          path: "/login",
          query: { redirect: location.href }
        });
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        let data = {
          ...values,
          enterTime: this.$moment(values.enterTime) || null,
          leaveTime: this.$moment(values.leaveTime) || null
        };
        if (!err) {
          if (this.type == "edit") {
            try {
              const education = await Api.User.editProjectHistory(
                data,
                this.id
              );
              if (education) {
                this.$message.success("修改成功");
                this.goBack();
              } else {
                this.$message.error("修改失败");
              }
            } catch (e) {
              this.$message.error(e);
            }
          } else {
            try {
              const education = await Api.User.createProjectHistory(data);
              if (education) {
                this.$message.success("添加成功");
                this.goBack();
              } else {
                this.$message.error("添加失败");
              }
            } catch (e) {
              this.$message.error(e);
            }
          }
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped></style>
